import { Backdrop, CircularProgress } from '@mui/material';
import { useJsMethodLoading } from './jsMethodLoadingContext';

export const JsMethodLoadingOverlay = () => {
  const { isAnyLoading } = useJsMethodLoading();

  return (
    <Backdrop
      open={isAnyLoading}
      sx={{
        position: 'absolute',
        zIndex: 1,
        flexDirection: 'column',
        gap: 1,
        color: (theme) =>
          theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main,
        bgcolor: (theme) =>
          theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.55)' : 'rgba(255, 255, 255, 0.72)',
      }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
